// src/hooks/useJoinBattle.js
import { useState } from "react";
import { joinBattle as joinBattleApi } from "../api/battleApi";

export function useJoinBattle() {
  const [joining, setJoining] = useState(false);

  const joinBattle = async ({ battleId, userId, team }) => {
    setJoining(true);
    try {
      await joinBattleApi({ battleId, userId, team });
    } finally {
      setJoining(false);
    }
  };

  return { joining, joinBattle };
}
